module.exports = __webpack_public_path__ + "img/brand-orbis.e6ded471.png";